export default __webpack_public_path__ + "static/media/Dire Sweetpressed Haste.826b2957.jpg";